import * as React from "react";

const SvgIcnLogoutBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M4.432 12.5l1.844 1.828c.094.104.14.224.14.36a.521.521 0 01-.14.359.712.712 0 01-.172.101.484.484 0 01-.375 0 .712.712 0 01-.172-.101l-2.273-2.334a1 1 0 010-1.395l2.273-2.334a.494.494 0 01.719 0c.094.094.14.211.14.352 0 .14-.046.258-.14.351L4.463 11.5h8.625c.146 0 .266.047.36.14.093.094.14.214.14.36a.494.494 0 01-.5.5H4.432zM18.558 4c.283 0 .528.096.735.29.207.192.31.429.31.71v14a.933.933 0 01-.31.71c-.207.194-.452.29-.735.29H9.666c-.295 0-.542-.096-.744-.29A.945.945 0 018.62 19v-4.024c0-.271.22-.492.491-.492h5c2.508 0 2.639-4.984 0-4.984H9.144a.523.523 0 01-.523-.523V5c0-.281.1-.518.302-.71.202-.194.45-.29.744-.29h8.892z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnLogoutBold;
